<div class="migration-switcher-toggle" [ngClass]="{ settled: isSettled }">
    <div class="migration-switcher-toggle-buttons">
        @for (tab of tabs; track $index) {
            <div class="migration-switcher-toggle-button" [class.active]="tab.selected" (click)="onSelectTab(tab)">
                {{ tabNames[tab.typeFilter] }}
            </div>
        }
    </div>
    <span class="betslip-summary__wins__info-icon">
        <button class="info-icon-btn" ds-button-icon size="small" variant="flat-reduce" kind="tertiary" (click)="showMigrationInfo()">
            <vn-icon name="theme-info" />
        </button>
    </span>
</div>
@if (migrationInfo) {
    <ms-my-bets-migration-info (close)="closeMigrationInfo()" />
}
